module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainContent"
  }, [_c('van-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, _vm._l((_vm.faqList), function(item, index) {
    return _c('van-collapse-item', {
      key: index,
      attrs: {
        "size": "large",
        "name": index
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_c('div', [_c('van-icon', {
            attrs: {
              "name": "question"
            }
          }), _vm._v(" " + _vm._s(item.question))], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(_vm._s(item.answer) + "\n      ")])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59acc5b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/FAQ.vue
// module id = 481
// module chunks = 1